var lib_core = require("./index.js");
var Model = require("./model.js");

var UserModel = function () {
    Model.apply(this);

    this.noAuthentication = this.value("noAuthentication", true);
    this.name = this.value("name", true);
    this.id = this.value("id", true);
    this.email = this.value("email", true);
    this.avatar = this.value("avatar", true);
    this.role = this.value("role", true);
};
lib_core.inherit(UserModel, Model);
lib_core.JsonParser.registerClass(UserModel, "UserModel");

module.exports = UserModel;
